import React, { useState, useCallback } from 'react';
import { GenericListPage } from '../../components/generic';
import { useOffers, Offer } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import { useTheme } from '../../contexts/ThemeContext';
import OfferFollowUpsPanel from './OfferFollowUpsPanel';

const List: React.FC = () => {
  const { colors } = useTheme();
  const [followUpsPanelOpen, setFollowUpsPanelOpen] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState<Offer | null>(null);
  const { mutate } = useOffers();

  const openFollowUpsPanel = useCallback((offer: Offer) => {
    setSelectedOffer(offer);
    setFollowUpsPanelOpen(true);
  }, []);

  const closeFollowUpsPanel = useCallback(() => {
    setFollowUpsPanelOpen(false);
    setSelectedOffer(null);
  }, []);

  return (
    <>
      <GenericListPage<Offer>
        useData={useOffers}
        listContext={{ onOpenFollowUpsPanel: openFollowUpsPanel }}
        config={{
          ...moduleConfig,
          defaultTableDensity: 'compact',
          getColumns: (formatDate, formatCurrency, colorsFromPage, listContext) =>
            getColumns(formatDate, formatCurrency, colorsFromPage ?? colors, listContext),
          getToolbarIcon,
          getTableActions: (item, onDelete, _c, _ctx, opts) => getTableActions(item, onDelete, colors, undefined, opts),
        }}
      />
      <OfferFollowUpsPanel
        open={followUpsPanelOpen}
        onClose={closeFollowUpsPanel}
        offer={selectedOffer}
        onFollowUpAdded={mutate}
        variant="modal"
      />
    </>
  );
};

export default List;
